"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetCustomerAccessToken = void 0;
const tslib_1 = require("tslib");
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const useGetCustomerAccessToken = (props) => {
    const { authState } = props;
    const { isAuthenticated, getAccessToken, isAnonymousCsr } = authState;
    return (0, react_1.useCallback)((options = {}) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
        try {
            if (!isAuthenticated || isAnonymousCsr) {
                return;
            }
            else {
                return yield getAccessToken(options);
            }
        }
        catch (error) {
            return;
        }
    }), [getAccessToken, isAuthenticated, isAnonymousCsr]);
};
exports.useGetCustomerAccessToken = useGetCustomerAccessToken;
//# sourceMappingURL=use-get-customer-access-token.js.map